import { useState, useEffect } from 'react';

const useDeferred = (value) => {
  const [state, setState] = useState(value);
  useEffect(() => {
    setState(value);
  }, [
    value
  ]);
  return state;
};

export { useDeferred as default };
//# sourceMappingURL=useDeferred.js.map
